import { Component, OnInit } from '@angular/core';
import {BaseComponent} from '../../shared/components/base/base.component';
import {CommonService} from '../../core/services/common.service';
import {DowloadAppService} from '../../core/services/dowload-app.service';
import { Message } from 'src/app/core/class/message';
@Component({
  selector: 'app-dowload-app',
  templateUrl: './dowload-app.component.html',
  styleUrls: ['./dowload-app.component.scss']
})
export class DowloadAppComponent extends BaseComponent implements OnInit {

  constructor(
    public dowloadService: DowloadAppService,
    public commonService: CommonService,
    public message: Message,
  ) {
    super(commonService, message);
  }

  ngOnInit() {
    this.redirectToAppStoreOrPlayStore();
  }

  openAppStore(): void {
    window.location.href = 'https://apps.apple.com/vn/app/vcontract/id1611141207';
  }

  openPlayStore(): void {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.viettel.vcontract';
  }

  redirectToAppStoreOrPlayStore(): void {
    if (this.dowloadService.isIOS()) {
      this.openAppStore();
    } else {
      this.openPlayStore();
    }
  }

}
